export default {
    medicalSpecialty: 'تخصص پزشکی ',
    medicalSpecialtiesTitle: 'عنوان',
    medicalSpecialtiesStatus: 'وضعیت',
    medicalSpecialties: 'تخصص های پزشکی ',
    editMedicalSpecialties: 'ویرایش تخصص های پزشکی ',
    addMedicalSpecialties: 'تخصص های پزشکی  جدید',
}